/* eslint-disable no-prototype-builtins */
/* eslint-disable import/prefer-default-export */
export const exchange = {
  FIAT_VALUE: 2,
  FIAT_LESS_ONE_VALUE: 4,
  CRYPTO_VALUE: 8,
  MAX_PRECISION: 8,
};

export const VerificationState = {
  UNVERIFIED: 0,
  PENDING: 1,
  DENIED: 2,
  VERIFIED: 3,
  CHECKED: 4,
  EDD_REQUIRED: 5,
  EDD_SUBMITED: 6,
};

export const verifyEmailScopes = {
  SIGNUP: 'sign_up',
  RESET_PASSWORD: 'reset_password',
};

export const walletTypes = {
  INTERNAL: 'internal',
  FIAT: 'fiat',
  CRYPTO: 'crypto',
  ADVANCED: 'advance',
  STABLE: 'stable',
};

export const currenciesDefault = {
  BTC: {
    fullName: 'Bitcoin',
    displayName: 'BTC',
    color: '#F89E32',
    icon: 'BTC',
    conversion: 1e-8,
    decimal: 8,
    type: 'crypto',
  },
  BCH: {
    fullName: 'Bitcoin Cash',
    displayName: 'BCH',
    color: '#F89E33',
    icon: 'BCH',
    conversion: 1e-8,
    decimal: 8,
    type: 'crypto',
  },
  ETH: {
    fullName: 'Ethereum',
    displayName: 'ETH',
    color: '#467493',
    icon: 'ETH',
    conversion: 1e-8,
    decimal: 8,
    type: 'crypto',
  },
  LTC: {
    fullName: 'Litecoin',
    displayName: 'LTC',
    color: '#2166B3',
    icon: 'LTC',
    conversion: 1e-8,
    decimal: 8,
    type: 'crypto',
  },
  XRP: {
    fullName: 'Ripple',
    displayName: 'XRP',
    color: '#359FE1',
    icon: 'XRP',
    conversion: 1e-8,
    decimal: 8,
    type: 'crypto',
  },
  XTZ: {
    fullName: 'Tezos',
    displayName: 'XTZ',
    color: '#2c7df7',
    icon: 'XTZ',
    conversion: 1e-8,
    decimal: 8,
    type: 'crypto',
  },
  BXX: {
    fullName: 'Baanx',
    displayName: 'BXX',
    color: '#05249b',
    icon: 'BXX',
    conversion: 1e-8,
    decimal: 8,
    type: 'crypto',
  },
  '1INCH': {
    fullName: '1inch',
    displayName: '1INCH',
    color: '#05249b',
    icon: '1INCH',
    conversion: 1e-8,
    decimal: 8,
    type: 'crypto',
  },
  UNI: {
    fullName: 'Uniswap',
    displayName: 'UNI',
    color: '#05249b',
    icon: 'UNI',
    conversion: 1e-8,
    decimal: 8,
    type: 'crypto',
  },
  SOL: {
    fullName: 'Solana',
    displayName: 'SOL',
    color: '#05249b',
    icon: 'SOL',
    conversion: 1e-8,
    decimal: 8,
    type: 'crypto',
  },
  GBP: {
    fullName: 'GBP',
    displayName: 'GBP',
    color: '#545556',
    icon: 'GBP',
    conversion: 1e-8,
    decimal: 2,
    supportFund: true,
    symbol: '£',
    currencyName: 'British Pound',
    type: 'fiat',
  },
  EUR: {
    fullName: 'EUR',
    displayName: 'EUR',
    color: '#545556',
    icon: 'EUR',
    conversion: 1e-8,
    decimal: 2,
    supportFund: true,
    symbol: '€',
    currencyName: 'Euro',
    type: 'fiat',
  },
  ZAR: {
    fullName: 'ZAR',
    displayName: 'ZAR',
    color: '#545556',
    icon: 'ZAR',
    conversion: 1e-8,
    decimal: 2,
    supportFund: false,
    symbol: 'R',
    currencyName: 'South African Rand',
    type: 'fiat',
  },
  USD: {
    fullName: 'USD',
    displayName: 'USD',
    color: '#545556',
    icon: 'USD',
    conversion: 1e-8,
    decimal: 2,
    supportFund: false,
    symbol: '$',
    currencyName: 'US Dollar',
    type: 'fiat',
  },
  USDT: {
    fullName: 'USDT',
    displayName: 'USDT',
    color: '#54ad95',
    icon: 'USDT',
    conversion: 1e-8,
    decimal: 8,
    type: 'stable',
  },
  USDC: {
    fullName: 'USDC',
    displayName: 'USDC',
    color: '#54ad95',
    icon: 'USDC',
    conversion: 1e-8,
    decimal: 8,
    type: 'stable',
  },
  EURT: {
    fullName: 'EURT',
    displayName: 'EURT',
    color: '#54ad95',
    icon: 'EURT',
    conversion: 1e-8,
    decimal: 8,
    type: 'stable',
  },
  EUROC: {
    fullName: 'EURC',
    displayName: 'EURC',
    color: '#299af5',
    icon: 'EUROC',
    conversion: 1e-8,
    decimal: 8,
    type: 'stable',
  },
  EURS: {
    fullName: 'EURS',
    displayName: 'EURS',
    color: '#299af5',
    icon: 'EURS',
    conversion: 1e-8,
    decimal: 8,
    type: 'stable',
  },
  CLEUR: {
    fullName: 'CLEUR',
    displayName: 'CLEUR',
    color: '#545556',
    icon: 'CLEUR',
    conversion: 1e-8,
    decimal: 2,
    type: 'stable',
  },
  CLGBP: {
    fullName: 'CLGBP',
    displayName: 'CLGBP',
    color: '#545556',
    icon: 'CLGBP',
    conversion: 1e-8,
    decimal: 2,
    type: 'stable',
  },
  EURLOAN: {
    fullName: 'EUR',
    displayName: 'EUR',
    color: '#299af5',
    icon: 'EUR',
    conversion: 1e-8,
    decimal: 2,
    symbol: '€',
    currencyName: 'Euro',
  },
  GBPLOAN: {
    fullName: 'GBP',
    displayName: 'GBP',
    color: '#299af5',
    icon: 'GBP',
    conversion: 1e-8,
    decimal: 2,
    symbol: '£',
  },
  USDLOAN: {
    fullName: 'USD',
    displayName: 'USD',
    color: '#299af5',
    icon: 'USD',
    conversion: 1e-8,
    decimal: 2,
    symbol: '$',
  },
};

const defaultAsset = (property) => ({
  fullName: property.toUpperCase(),
  displayName: property.toUpperCase(),
  color: '#545556',
  icon: 'USD',
  conversion: 1e-8,
  decimal: 8,
});

export const currencies = new Proxy(currenciesDefault, {
  get: (object, property) =>
    object.hasOwnProperty(property.toUpperCase())
      ? object[property.toUpperCase()]
      : defaultAsset(property.toUpperCase()),
});

export const sharedSetting = {
  RESEND_WAIT_TIME: 60,
  MODES_2FA: {
    sms: 'sms',
    otp: 'otp',
  },
};

export const LOCAL_STORAGE_KEYS = {
  USER_ACCESS_TOKEN: 'user.access_token',
  USER_ACCESS_TOKEN_PARTIAL_LOGIN: 'user.partial_login',
  USER_HIDDEN_CURRENCY_LIST: 'user.currency_list',
  FIRST_USAGE: 'FIRST_USAGE',
  USER_ENVIRONMENT: 'user.user_environment',
  FIRST_ACCESS: 'user.first_access',
  SHOW_BANNER: 'SHOW_BANNER',
  SHOW_CARD_HINT: 'card.showHint',
  SHOW_CRYPTODRAFT_BANNER: 'cryptodraft.banner',
  RECAPTCHA_V3_FAILURE: 'recaptcha_v3_failure',
  USER_WANTS_TO_STAY_IN_US_APP: 'user.wants_to_stay_in_us_app',
  USER_WANTS_TO_STAY_IN_INTERNATIONAL_APP: 'user.wants_to_stay_in_international_app',
};

export const ASSETS_PATHS = {
  flagIconsPath: './assets/images/flags/1x1/',
};

export const PATHS = {
  settings: '/dashboard/user/settings',
};

export const MASKED_NUMBER_PHONE_LENGTH = 7;
export const LEDGER_TO_DISPLAY_FACTOR = 1e-8;

export const MAXIMUM_LINKED_WALLETS = 5;

export const CARD_TYPE = [
  {
    state: 'virtual_card_option',
    content: 'virtual_card_option_content',
    selected: false,
  },
  {
    state: 'physical_card_option',
    content: 'physical_card_option_content',
    selected: false,
  },
];

export const CARD_TYPE_STATUS = {
  PHYSICAL: 'physical_card_option',
  VIRTUAL: 'virtual_card_option',
};

export const CARD_DELIVERY_TYPE = {
  galileo: [
    {
      state: 'standart_option',
      content: 'standart_option_content',
      selected: false,
    },
    {
      state: 'expedited_option',
      content: 'expedited_option_content',
      selected: false,
    },
  ],
};

export const REPORT_CARD_OPTIONS = {
  monavate: [
    {
      state: 'lost',
      label: 'lost_stolen_label',
      selected: false,
      allow_card_replacement_order: true,
    },
    {
      state: 'stolen',
      label: 'lost_stolen_label',
      selected: false,
      allow_card_replacement_order: true,
    },
  ],
  galileo: [
    {
      state: 'lost',
      selected: false,
      allow_card_replacement_order: true,
    },
    {
      state: 'stolen',
      selected: false,
      allow_card_replacement_order: true,
    },
    {
      state: 'damaged_or_not_working',
      selected: false,
    },
  ],
};

export const REPORT_CARD_STATUS = {
  LOST: 'lost',
  STOLEN: 'stolen',
  DAMAGED: 'damaged',
  DAMAGEDNOTWORK: 'damaged_or_not_working',
};

export const DELIVERY_TYPE_STATUS = {
  STANDARD: 'standart_option',
  EXPEDITED: 'expedited_option',
};

export const USA = 'UNITED STATES OF AMERICA';

// ? should come from backend ?
export const CONTACT_DETAILS = {
  baanx: {
    USA: {
      name: 'Baanx US Corp',
      phone: '833-998-2466',
      email: 'support@cl-cards.com',
      website: 'www.baanx.com',
    },
  },
  gov: {
    USA: {
      phone: '1-855-411-2372',
      website_prepaid: 'consumerfinance.gov/consumer-tools/prepaid-cards',
      website_complaint: 'consumerfinance.gov/complaint',
    },
  },
};
// eslint-disable-next-line no-restricted-globals
export const BASE_ROUTE = location.hostname.indexOf('baanx.co.uk') > 0 ? '/iframeV2/view' : '/';

export const TIER_LEVEL = {
  ZERO: 'tier0',
  ONE: 'tier1',
  TWO: 'tier2',
  THREE: 'tier3',
  FOUR: 'tier4',
  FIVE: 'tier5',
  SIX: 'tier6',
  SEVEN: 'tier7',
  EIGHT: 'tier8',
  NINE: 'tier9',
  TEN: 'tier10',
};

export const TIER_LEVEL_TITLE = {
  BASIC: 'Basic',
  ADVANCED: 'Advanced',
  PRO: 'Pro',
};

export const CardMastercardTransactionTypesString = {
  SETTLED: 'SETTLED',
  DECLINED: 'DECLINED',
};

export const EUROPE_COUNTRIES = [
  'Austria',
  'Italy',
  'Belgium',
  'Latvia',
  'Bulgaria',
  'Lithuania',
  'Croatia',
  'Luxembourg',
  'Cyprus',
  'Malta',
  'Czech Republic',
  'Netherlands',
  'Denmark',
  'Poland',
  'Estonia',
  'Portugal',
  'Finland',
  'Romania',
  'France',
  'Slovakia',
  'Germany',
  'Slovenia',
  'Greece',
  'Spain',
  'Hungary',
  'Sweden',
  'Ireland',
];

export const EUROPE_COUNTRIES_ALPHA3 = [
  'AUT', // Austria
  'ITA', // Italy
  'BEL', // Belgium
  'LVA', // Latvia
  'BGR', // Bulgaria
  'LTU', // Lithuania
  'HRV', // Croatia
  'LUX', // Luxembourg
  'CYP', // Cyprus
  'MLT', // Malta
  'CZE', // Czechia
  'NLD', // Netherlands
  'DNK', // Denmark
  'POL', // Poland
  'EST', // Estonia
  'PRT', // Portugal
  'FIN', // Finland
  'ROU', // Romania
  'FRA', // France
  'SVK', // Slovakia
  'DEU', // Germany
  'SVN', // Slovenia
  'GRC', // Greece
  'ESP', // Spain
  'HUN', // Hungary
  'SWE', // Sweden
  'IRL', // Ireland
];

export const ACCOUNT_REGIONS = {
  US: 'US',
  UK_OR_EU: 'UK_OR_EU',
};

export const ALLOWED_ROUTES_WITHOUT_TOTP = [
  '/promo',
  '/onboarding/login',
  '/onboarding/signup',
  '/onboarding/totp-secret',
  '/onboarding/totp-secret-save',
  '/onboarding/totp-verify',
  '/onboarding//totp-reset-secret',
  '/onboarding/signup/email-success/verification/email-verification',
  '/onboarding/signup/magic-link',
  '/onboarding/signup/personal-information',
  '/onboarding/signup/phone-number',
  '/onboarding/signup/confirm-phone-number',
  '/onboarding/signup/address-information',
  '/onboarding/signup/mailing-address',
  '/onboarding/reset-password',
  '/onboarding/reset-password/sent',
  '/reset-password/confirm-phone-number',
];

export const byteUnitsOptions = {
  KB: 'kB',
  MB: 'MB',
  GB: 'GB',
  TB: 'TB',
  PB: 'PB',
  EB: 'EB',
  ZB: 'ZB',
  YB: 'YB',
};
// Supported families are in node_modules\@ledgerhq\live-app-sdk\dist\families\types.d.ts
export const LEDGER_BAANX_CURRENCY_NAME_MAP = {
  btc: 'bitcoin',
  eth: 'ethereum',
  xrp: 'ripple',
  xtz: 'tezos',
  ltc: 'litecoin',
  usdt: 'usdt',
  usdc: 'usdc',
  bxx: 'bxx',
  eurt: 'eurt',
  eurc: 'eurc',
  '1inch': '1inch',
  sol: 'solana',
  uni: 'uniswap',
};

export const MAX_COIN_ADDRESS_LENGTH = 42;

export const featuresScreens = {
  SELECT_WALLET: 'select_wallet',
  WALLET_HINTS: 'wallet_hints',
};

export const walletType = {
  APPLE_WALLET: 'apple_wallet',
  GOOGLE_WALLET: 'google_wallet',
};

export const loyaltyScreens = {
  SELECT_CASHBACK: 'select_cashback',
  CLAIM_REWARD: 'claim_reward',
};
